export function triggerFileDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.style.display = "none";

  document.body.appendChild(a);
  a.click();
  a.remove();

  // Delay revoke so the browser can start the download before the blob URL is released.
  window.setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 1000);
}
